export enum HighlightsFilterEnum {
  GLOBAL = 'global',
  FILTER = 'filter',
  CATEGORY = 'category',
}
